webpackJsonp([35783957827783],{

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(473);
	
	__webpack_require__(545);
	
	__webpack_require__(244);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(69);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(81);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(80);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(153);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(152);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-principal.9a2ab62e.jpg";

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: #202122;\n  & .content {\n    background: white;\n    margin: 0 60px;\n    padding: 10px 35px;\n    letter-spacing: -1px;\n    color: #6e6e6e;\n    ", ";\n  }\n  & .link {\n    color: #fff;\n    text-decoration: underline;\n  }\n"], ["\n  background: #202122;\n  & .content {\n    background: white;\n    margin: 0 60px;\n    padding: 10px 35px;\n    letter-spacing: -1px;\n    color: #6e6e6e;\n    ", ";\n  }\n  & .link {\n    color: #fff;\n    text-decoration: underline;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      margin: 0;\n    "], ["\n      margin: 0;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  background: #202122;\n  border-radius: 2px;\n  padding-left: 35px;\n  padding-right: 35px;\n  padding: 10px 35px;\n  letter-spacing: -1px;\n  color: #6e6e6e;\n\n  & p {\n    font-size: 20px;\n    color: #fff;\n    line-height: 1.8;\n    margin: 15px auto;\n    padding: 0 40px;\n    letter-spacing: 1px;\n  }\n  & a {\n    text-transform: uppercase;\n    font-family: \"Muller\";\n    font-weight: 500;\n    font-style: normal;\n    letter-spacing: 1px;\n    padding: 13px 20px;\n    color: #202122;\n    font-size: 20px;\n    margin-top: 0;\n    background: #999a9f;\n    background: -moz-linear-gradient(\n      -45deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    background: -webkit-linear-gradient(\n      -45deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    background: linear-gradient(\n      135deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );\n    display: inline-block;\n  }\n"], ["\n  text-align: center;\n  background: #202122;\n  border-radius: 2px;\n  padding-left: 35px;\n  padding-right: 35px;\n  padding: 10px 35px;\n  letter-spacing: -1px;\n  color: #6e6e6e;\n\n  & p {\n    font-size: 20px;\n    color: #fff;\n    line-height: 1.8;\n    margin: 15px auto;\n    padding: 0 40px;\n    letter-spacing: 1px;\n  }\n  & a {\n    text-transform: uppercase;\n    font-family: \"Muller\";\n    font-weight: 500;\n    font-style: normal;\n    letter-spacing: 1px;\n    padding: 13px 20px;\n    color: #202122;\n    font-size: 20px;\n    margin-top: 0;\n    background: #999a9f;\n    background: -moz-linear-gradient(\n      -45deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    background: -webkit-linear-gradient(\n      -45deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    background: linear-gradient(\n      135deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );\n    display: inline-block;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  padding-top: 10px;\n  min-height: 160px !important;\n\n  & .block-content {\n    min-height: 160px;\n    text-align: center;\n    padding-top: 10px;\n  }\n  & .inner {\n    font-family: \"Muller\";\n    font-weight: 300;\n    font-style: normal;\n    text-align: center;\n    font-size: 14px;\n    color: #000000;\n\n    & p {\n      font-size: 14px;\n    }\n\n    & .img-logo {\n      width: 80%;\n      height: 80%;\n      left: 0px;\n      right: 0px;\n      margin: auto;\n    }\n  }\n\n  & .instructions {\n    font-size: 12px;\n    color: #666666;\n    text-decoration: none;\n  }\n\n  ", ";\n\n  ", ";\n"], ["\n  text-align: center;\n  padding-top: 10px;\n  min-height: 160px !important;\n\n  & .block-content {\n    min-height: 160px;\n    text-align: center;\n    padding-top: 10px;\n  }\n  & .inner {\n    font-family: \"Muller\";\n    font-weight: 300;\n    font-style: normal;\n    text-align: center;\n    font-size: 14px;\n    color: #000000;\n\n    & p {\n      font-size: 14px;\n    }\n\n    & .img-logo {\n      width: 80%;\n      height: 80%;\n      left: 0px;\n      right: 0px;\n      margin: auto;\n    }\n  }\n\n  & .instructions {\n    font-size: 12px;\n    color: #666666;\n    text-decoration: none;\n  }\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    min-height: auto !important;\n  "], ["\n    min-height: auto !important;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    min-height: 125px !important;\n  "], ["\n    min-height: 125px !important;\n  "]);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(486);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(31);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(235);
	
	var _template = __webpack_require__(79);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _theme = __webpack_require__(55);
	
	var _media = __webpack_require__(35);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _imgPrincipal = __webpack_require__(567);
	
	var _imgPrincipal2 = _interopRequireDefault(_imgPrincipal);
	
	var _descuentosInfo = __webpack_require__(569);
	
	var _descuentosInfo2 = _interopRequireDefault(_descuentosInfo);
	
	var _ModalCondition = __webpack_require__(78);
	
	var _ModalCondition2 = _interopRequireDefault(_ModalCondition);
	
	__webpack_require__(482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject, _media2.default.md(_templateObject2));
	var Franja = _styledComponents2.default.div(_templateObject3);
	
	var Municipio = _styledComponents2.default.div(_templateObject4, _media2.default.sm(_templateObject5), _media2.default.xs(_templateObject6));
	
	var customStyles = {
	  content: {
	    top: "50%",
	    left: "50%",
	    right: "auto",
	    bottom: "auto",
	    marginRight: "-50%",
	    transform: "translate(-50%, -50%)"
	  }
	};
	var ImpuestosMunicipales = function ImpuestosMunicipales(props) {
	  var _useState = (0, _react.useState)(false),
	      isOpen = _useState[0],
	      setIsOpen = _useState[1];
	
	  function toggleModal() {
	    setIsOpen(!isOpen);
	  }
	
	  var municipios = props.data.allMunicipiosCsv.edges.map(function (_ref) {
	    var _ref$node = _ref.node,
	        id = _ref$node.id,
	        name = _ref$node.name,
	        url = _ref$node.url,
	        image = _ref$node.image,
	        instructions = _ref$node.instructions,
	        classAnalitics = _ref$node.classAnalitics;
	
	    var logo = props.data.allImageSharp.edges.find(function (_ref2) {
	      var originalName = _ref2.node.sizes.originalName;
	
	      return originalName === image;
	    });
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        Municipio,
	        {
	          className: "col-md-3 col-sm-4 col-xs-6 block-content",
	          key: id
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            href: url,
	            className: "inner " + classAnalitics,
	            "data-store": name,
	            target: "_blank"
	          },
	          _react2.default.createElement(_gatsbyImage2.default, { className: "img-logo", sizes: logo.node.sizes, alt: name }),
	          _react2.default.createElement(
	            "p",
	            null,
	            name
	          )
	        )
	      )
	    );
	  });
	
	  var subtitle = "1% de descuento.";
	  var title = "Paga tu impuesto predial en línea con";
	  return _react2.default.createElement(
	    _template2.default,
	    { banner: _imgPrincipal2.default, title: title, subtitle: subtitle, active: "municipales" },
	    function (_ref3) {
	      var handleModalShow = _ref3.handleModalShow;
	      return _react2.default.createElement(
	        ContentWrapper,
	        { className: "row" },
	        _react2.default.createElement(
	          _theme.Container,
	          { className: "title" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Descuentos por pronto pago de impuesto predial urbano"
	              ),
	              _react2.default.createElement("img", { src: _descuentosInfo2.default }),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Realice su pago en estos municipios usando",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    id: "CORPIMP_MPAL_NEWKEY",
	                    className: "link",
	                    onClick: toggleModal
	                  },
	                  " ",
	                  "la nueva clave temporal."
	                ),
	                _react2.default.createElement(_ModalCondition2.default, {
	                  onAfterOpen: false,
	                  isOpen: isOpen,
	                  onRequestClose: toggleModal,
	                  ariaHideApp: false,
	                  contentLabel: "ModalMunicipio"
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _theme.Container,
	          { className: "content" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            municipios
	          )
	        ),
	        _react2.default.createElement(
	          Franja,
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "row" },
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { "class": "contenido2-caja-contenedor" },
	                _react2.default.createElement(
	                  "p",
	                  { "class": "contenido2-txt2 text-center" },
	                  "Adem\xE1s recuerde que puede pagar sus impuestos acerc\xE1ndose directamente a ventanillas en los siguientes municipios."
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "row" },
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-12" },
	              _react2.default.createElement(
	                "div",
	                { "class": "text-center" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "https://diners-ecuador.s3.amazonaws.com/documents/listado_municipios_corporativo.pdf",
	                    target: "_blank",
	                    "class": "link-block btn-default-impuestos btn-default-impuestos-uppercase",
	                    id: "CORPIMP_MPAL_CONOZCA"
	                  },
	                  "Ver Municipios"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  );
	};
	
	exports.default = ImpuestosMunicipales;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a1f349b3579e53f918cc.js